module.exports = __webpack_public_path__ + "static/media/comment-plus.579c1257.svg";